import thunk from 'redux-thunk';
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import graphicUploadReducer from './reducers/graphicUploadReducer';
import kapinuaColorsReducer from './reducers/kapinuaColorsReducer';
import graphicsLibraryReducer from './reducers/graphicsLibraryReducer';
import changeStyleReducer from './reducers/changeStyleReducer';
import snackbarReducer from './reducers/snackbarReducer';
import saveDesignReducer from './reducers/saveDesignReducer';
import buyDialogReducer from './reducers/buyDialogReducer';
import onlineDesignerReducer from './reducers/onlineDesignerReducer';
import changeGraphicColorReducer from './reducers/changeGraphicColor';

/* eslint-disable no-underscore-dangle */
const composeEnhancers =
    process.env.NODE_ENV === 'development' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        : null || compose;
/* eslint-enable */

export const appReducer = combineReducers({
    kapinuaColors: kapinuaColorsReducer,
    graphicUpload: graphicUploadReducer,
    graphicLibrary: graphicsLibraryReducer,
    changeStyle: changeStyleReducer,
    snackbar: snackbarReducer,
    saveDesign: saveDesignReducer,
    buyDialog: buyDialogReducer,
    od: onlineDesignerReducer,
    changeGraphicColor: changeGraphicColorReducer,
});

const store = createStore(appReducer, composeEnhancers(applyMiddleware(thunk)));

export default store;
